
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn/inbody-in-studies",
      function () {
        return require("private-next-pages/learn/inbody-in-studies/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learn/inbody-in-studies"])
      });
    }
  